import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { AppConfigService } from '@tmhcc-ng-lib/global-services';
import { BaseDataService } from './base-data-service';
import { GoogleAnalyticResponse } from './def/steps';

import { GlobalVariablesService } from './global-variables.service';
import { appendRelativePathToUrl } from '@tmhcc/util';
import { environment } from 'apps/artisan/src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticService extends BaseDataService {
  loaded: boolean;
  data;
  constructor(
    protected http: HttpClient,
    protected configService: AppConfigService,
    protected globalVariables: GlobalVariablesService
  ) {
    super(http, configService, globalVariables);
  }

  getGoogleAnalyticTrakinId(): Observable<GoogleAnalyticResponse> {
    const url = this.getServiceUrl('configuration/AEPO');
    return this.get<GoogleAnalyticResponse>(url);
  }

  getServiceUrl(servicePath: string): string {
    return appendRelativePathToUrl(
      environment.oktaWidgetConfig.issuer,
      servicePath
    );
  }
}
